<template>
  <div class="Inicio">
    <div class="banner_dvw">
      <div class="banner_dv1">
        <img class="banner_1img" src="@/assets/img/banner_1.webp" alt="">
      </div>
      <div class="moneymex_banner_text">
          <div class="moneymex_banner_t1">Moneymex, te ofrece préstamos rápidos y confiables.</div>
          <div class="moneymex_banner_t2">Hasta <em>20,000</em> pesos mexicanos depositados directamente en tu cuenta, con aprobación en línea en <em>10</em> minutos. Todo el proceso es seguro y sin complicaciones.</div>
          <div class="moneymex_banner_t3">
            <img src="@/assets/img/moneymex_googleplay.webp" alt="">
          </div>
      </div>
    </div>

    <div class="moneymex_desc">
      <div class="moneymex_desc_title">
        <div class="moneymex_desc_tdv">
          <div class="moneymex_desc_tdvu">
            <div class="moneymex_desc_tdvu_1">¿Por qué miles de usuarios eligen MoneyMex?</div>
            <div class="moneymex_desc_tdvu_2">No solo ofrecemos préstamos, sino también tranquilidad y una experiencia financiera sin complicaciones.</div>
          </div>
        </div>
      </div>
      <div class="moneymex_desc_view">
        <div class="moneymex_desc_vi1">
          <img src="@/assets/img/moneymex_desc_vi1.webp" alt="">
        </div>
        <div class="moneymex_desc_vi2">
          <img src="@/assets/img/moneymex_desc_vi2.webp" alt="">
        </div>
        <div class="moneymex_desc_vi3">
          <p>
            MoneyMex
          </p>
        </div>
        <div class="moneymex_desc_vi4">
          <img src="@/assets/img/moneymex_desc_vi4.webp" alt="">
        </div>
        <div class="moneymex_desc_vi5">
          <img src="@/assets/img/moneymex_desc_vi5.webp" alt="">
        </div>
      </div>
    </div>

    <div class="moneymex_list">
      <div class="moneymex_list_title">
        <div class="moneymex_list_title1">Solicitarlo es muy sencillo.</div>
        <div class="moneymex_list_title2">Sin trámites engorrosos: solo cuatro sencillos pasos y tus fondos se acreditarán al instante.</div>
      </div>
      <div class="moneymex_list_down">
        <div class="moneymex_list_dleft">
          <img src="@/assets/img/moneymex_list_dimg.webp" alt="">
        </div>
        <div class="moneymex_list_dright">
          <div class="moneymex_list_dritems">
            <div class="moneymex_list_dritems_nums"><em>01</em></div>
            <div class="moneymex_list_dritems_text">
              <div class="moneymex_list_dritems_ttitle">Descarga la aplicación.</div>
              <div class="moneymex_list_dritems_tdesc">Busca «MoneyMex» en Google Play y descarga la aplicación oficial.</div>
            </div>
          </div>
          <div class="moneymex_list_dritems">
            <div class="moneymex_list_dritems_nums"><em>02</em></div>
            <div class="moneymex_list_dritems_text">
              <div class="moneymex_list_dritems_ttitle">Completa la información básica/verifica tu identidad.</div>
              <div class="moneymex_list_dritems_tdesc">Debes tener una tarjeta de identificación nacional mexicana (INE) válida y una tarjeta bancaria.</div>
            </div>
          </div>
          <div class="moneymex_list_dritems">
            <div class="moneymex_list_dritems_nums"><em>03</em></div>
            <div class="moneymex_list_dritems_text">
              <div class="moneymex_list_dritems_ttitle">Envía tu solicitud.</div>
              <div class="moneymex_list_dritems_tdesc">Selecciona el monto del préstamo; el sistema mostrará los calendarios de pago y los cargos totales en tiempo real.</div>
            </div>
          </div>
          <div class="moneymex_list_dritems" style="padding: 0;">
            <div class="moneymex_list_dritems_nums"><em>04</em></div>
            <div class="moneymex_list_dritems_text">
              <div class="moneymex_list_dritems_ttitle">Espera el desembolso.</div>
              <div class="moneymex_list_dritems_tdesc" style="padding: 0;">Una vez aprobada la solicitud, los fondos se acreditarán de inmediato.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="moneymex_list" style="padding: 160px 0 0 0;">
      <div class="moneymex_list_title">
        <div class="moneymex_list_title1">Opiniones reales de clientes</div>
        <div class="moneymex_list_title2">No se limite a creer en nuestra palabra: vea lo que opinan realmente nuestros usuarios.</div>
      </div>

      <div class="beat_prize_wrap">
        <div class="beat_prize_cont">
          <div id="ndan_prizelist_cdv" class="ndan_prizelist_cdv">
            <ul>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/img/moneymex_scroll01.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/img/moneymex_scroll02.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/img/moneymex_scroll03.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/img/moneymex_scroll04.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/img/moneymex_scroll05.webp" alt="">
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import "./scss/Inicio.scss";

var spa = -1;
function move(oul){
  if(oul){
    if(oul.offsetLeft<-oul.offsetWidth/2){
      oul.style.left='0';
    }
    if(oul.offsetLeft>0){
      oul.style.left=-oul.offsetWidth/2+'px'
    }
    oul.style.left=oul.offsetLeft+spa+'px';
  }

}

function squareMove(oul) {
  function updateAnimation() {
    if(oul) {
      if (oul.offsetLeft < -oul.offsetWidth / 2) {
        oul.style.left = '0';
      }
      if (oul.offsetLeft > 0) {
        oul.style.left = -oul.offsetWidth / 2 + 'px'
      }
      //console.log(oul.offsetLeft+spa)
      oul.style.left = oul.offsetLeft + spa + 'px';
      window.requestAnimationFrame(updateAnimation)
    }
  }
  if(oul){
    oul.style.left='0';
    window.requestAnimationFrame(updateAnimation)
  }
}

export default {
  name: "Inicio",
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {
    var odiv = document.getElementById('ndan_prizelist_cdv');
    var oul = odiv.getElementsByTagName('ul')[0];
    var ali = oul.getElementsByTagName('li');
    oul.innerHTML=oul.innerHTML+oul.innerHTML;
    oul.style.width=ali[0].offsetWidth*ali.length+'px';

    // requestAnimationFrame版
    if(window.requestAnimationFrame){
      let timer = null;
      squareMove(oul);
      timer = squareMove();
      odiv.onmouseenter=function(){cancelAnimationFrame(timer);}
      odiv.onmouserleava=function(){timer = squareMove()};
    } else {
      // 定时器版
      move(oul)
      var timer = setInterval(move,30)
      odiv.onmouseenter=function(){clearInterval(timer);}
      odiv.onmouserleava=function(){timer = setInterval(move,30)};
    }
  },
  methods: {

  },
};
</script>

<style lang="scss">
  .banner_dvw{
    width: 100%;
    height: 1320px;
    position: relative;
    overflow: hidden;
    background: #0F0000;
  }
  .banner_dv1{
    width: 1920px;
    position: absolute;
    left: 50%;
    margin-left: -960px;
  }
  .moneymex_banner_text{
    width: 100%;
    height: 1320px;
    position: absolute;
    left: 0;
    top: 0;
    .moneymex_banner_t1{
      width: 1162px;
      height: 176px;
      padding: 203px 0 0 0;
      margin: 0 auto;
      font-family: OpenSans, OpenSans;
      font-weight: bold;
      font-size: 64px;
      color: #FFFFFF;
      line-height: 88px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .moneymex_banner_t2{
      width: 708px;
      height: 102px;
      padding: 32px 0 0 0;
      margin: 0 auto;
      font-family: OpenSans;
      font-size: 24px;
      color: rgba(255,255,255,0.8);
      line-height: 34px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      em {
        font-weight: bold;
        color: #ffffff;
        text-decoration: underline;
        text-underline: #ffffff;
      }
    }
    .moneymex_banner_t3{
      width: 206px;
      height: 68px;
      padding: 64px 0 0 0;
      margin: 0 auto;
      cursor: pointer;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .moneymex_desc{
    width: 100%;
    height: 1524px;
    background: #0F0000;
    .moneymex_desc_title{
      width: 100%;
      height: 264px;
      position: relative;
      .moneymex_desc_tdv{
        width: 100%;
        height: 264px;
        position: absolute;
        left: 0;
        top: -80px;
        .moneymex_desc_tdvu{
          width: 828px;
          height: 264px;
          margin: 0 auto;
          .moneymex_desc_tdvu_1{
            width: 100%;
            height: 144px;
            font-family: Roboto, Roboto;
            font-weight: bold;
            font-size: 60px;
            color: #FFFFFF;
            line-height: 72px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            padding: 0 0 24px 0;
          }
          .moneymex_desc_tdvu_2{
            width: 520px;
            height: auto;
            margin: 0 auto;
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 20px;
            color: #B4B6BD;
            line-height: 28px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }
    .moneymex_desc_view{
      width: 1320px;
      height: 1100px;
      margin: 0 auto;
      position: relative;
      .moneymex_desc_vi1{
        width: 426px;
        height: 662px;
        position: absolute;
        left: 0;
        top: 0;
      }
      .moneymex_desc_vi2{
        width: 870px;
        height: 414px;
        position: absolute;
        right: 0;
        top: 0;
      }
      .moneymex_desc_vi3{
        width: 420px;
        height: 224px;
        position: absolute;
        left: 450px;
        top: 438px;
        background: linear-gradient( 155deg, #453A27 0%, #3C2617 31%, #050402 100%, #040301 100%);
        border-radius: 16px;
        border: 2px solid;
        display: flex;
        justify-content: center;
        align-items: center;
        p{
          font-family: OpenSans, OpenSans;
          font-weight: bold;
          font-size: 44px;
          color: #FFFFFF;
          line-height: 60px;
          text-align: left;
        }
      }
      .moneymex_desc_vi4{
        width: 870px;
        height: 414px;
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .moneymex_desc_vi5{
        width: 426px;
        height: 662px;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  }
  .moneymex_list{
    width: 100%;
    height: auto;
    background: #0F0000;
    .moneymex_list_title{
      width: 100%;
      height: 272px;
      .moneymex_list_title1{
        width: 828px;
        height: 72px;
        margin: 0 auto;
        font-family: Roboto, Roboto;
        font-weight: bold;
        font-size: 60px;
        color: #FFFFFF;
        line-height: 72px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .moneymex_list_title2{
        width: 520px;
        height: 56px;
        margin: 24px auto 0 auto;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 20px;
        color: #808187;
        line-height: 28px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
    .moneymex_list_down{
      width: 1320px;
      height: auto;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .moneymex_list_dleft{
        width: 580px;
        height: 640px;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .moneymex_list_dright{
        width: 664px;
        height: auto;
        .moneymex_list_dritems{
          width: 100%;
          height: auto;
          display: flex;
          justify-content: space-between;
          padding: 0 0 56px 0;
          .moneymex_list_dritems_nums{
            width: 48px;
            height: 48px;
            padding: 0 30px 0 0;
            font-family: Montserrat, Montserrat;
            line-height: 48px;
            text-align: center;
            font-style: italic;
            text-transform: none;
            em {
              font-weight: bold;
              background: linear-gradient(90deg, #9BA7C8 0%, #E3D4C1 100%);
              -webkit-background-clip: text;
              color: transparent;
              font-size: 44px;
              padding: 0 10px 0 0;
            }
          }
          .moneymex_list_dritems_text{
            width: 100%;
            height: auto;
            .moneymex_list_dritems_ttitle{
              width: 100%;
              height: auto;
              padding: 0 0 20px 0;
              font-family: Roboto, Roboto;
              font-weight: bold;
              font-size: 40px;
              color: #FAFBFB;
              line-height: 48px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
            .moneymex_list_dritems_tdesc{
              width: 100%;
              height: auto;
              font-family: Roboto, Roboto;
              font-weight: 400;
              font-size: 24px;
              color: #B4B4BB;
              line-height: 36px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
          }
        }
      }
    }
  }

  .beat_prize_wrap{
    width: 100%;
    height: 404px;
    margin: 0 auto;
    position: relative;
  }
  .beat_prize_cont{
    width: 100%;
    height: 404px;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
  }
  .ndan_prizelist_cdv{
    width: 100%;
    height: 229px;
    border-radius: 0.305556rem;
    position: relative;
    overflow: hidden;
  }
  .ndan_prizelist_cdv ul { width: 100%; height: auto; position: relative;background: #ffffff;}
  .ndan_prizelist_cdv ul li {
    width: 374px;
    height: auto;
    float: left;
    list-style: none;
    margin-right: 5px;
    margin-bottom: 180px;
    border-radius: 10px;
  }
  .baroli_hscrollcdview{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0 12px;
  }
  .baroli_hscdv_head{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .baroli_hscdv_hleft{
    width: 260px;
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .baroli_hscdv_hlavator{
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .baroli_hscdv_hlavator img{
    display: block;
    width: 40px;
    height: 40px;
  }
  .baroli_hscdv_hlmobile{
    width: auto;
    height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #808187;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding-left: 12px;
  }
  .baroli_hscdv_hright{
    width: 108px;
    height: 20px;
  }
  .baroli_hscdv_hright img{
    display: block;
    width: 108px;
    height: 20px;
  }
  .baroli_hscdv_down{
    width: 100%;
    padding-top: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .baroli_hscrmask_left{
    width: 300px;
    height: 402px;
    background: linear-gradient( 270deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
    position: absolute;
    left: 0;
    top: 0;
  }
  .baroli_hscrmask_right{
    width: 300px;
    height: 402px;
    background: linear-gradient( 270deg,  #FFFFFF 0%, rgba(255,255,255,0)100%);
    position: absolute;
    right: 0;
    top: 0;
  }
</style>
